import React, { memo, useCallback, useMemo } from 'react';
import { fromJS } from 'immutable';

const NULL_VALUE = 'null';

const DEFAULT_OPTION_VALUE = 'Retain original status codes';

export default function withDoNothingOption(WrappedComboBox) {
  const WithDoNothingOption = props => {
    const { options, value, name, onChange, valueKey = 'value', nameKey = 'name' } = props;

    const comboOptions = useMemo(
      () =>
        fromJS([
          {
            [valueKey]: NULL_VALUE,
            [nameKey]: DEFAULT_OPTION_VALUE,
          },
        ]).concat(options),
      [nameKey, options, valueKey],
    );

    const handleChange = useCallback(
      event => {
        const { type, value: nextValue, checked = null } = event.target;

        if (typeof onChange === 'function') {
          onChange({
            target: {
              name,
              value: nextValue === NULL_VALUE ? null : nextValue,
              type,
              checked,
            },
          });
        }
      },
      [name, onChange],
    );

    const resolvedValue = value === null ? NULL_VALUE : value;

    return <WrappedComboBox {...props} onChange={handleChange} options={comboOptions} value={resolvedValue} />;
  };

  return memo(WithDoNothingOption);
}
